(function () {
  'use strict';

  // Sunday = 0 … Saturday = 6. Sat/Sun are closed.
  var DAY_PHRASE = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];

  function parseTime(str) {
    var parts = (str || '').split(':');
    if (parts.length !== 2) return -1;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    if (isNaN(h) || isNaN(m)) return -1;
    return h * 60 + m;
  }

  function formatTime(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return h + ':' + (m < 10 ? '0' : '') + m;
  }

  // Opening/closing minutes for a given weekday, or null when closed that day.
  function scheduleForDay(day, hours) {
    if (day >= 1 && day <= 4) {
      if (hours.monThuOpen < 0 || hours.monThuClose < 0) return null;
      return { open: hours.monThuOpen, close: hours.monThuClose };
    }
    if (day === 5) {
      if (hours.friOpen < 0 || hours.friClose < 0) return null;
      return { open: hours.friOpen, close: hours.friClose };
    }
    return null;
  }

  // Next opening after the current moment, expressed as a Czech phrase:
  // "v 8:00" (later today), "zítra v 8:00", "v úterý v 8:00".
  function nextOpening(day, currentMin, hours) {
    var today = scheduleForDay(day, hours);

    if (today && currentMin < today.open) {
      return 'v ' + formatTime(today.open);
    }

    for (var offset = 1; offset <= 7; offset++) {
      var candidateDay = (day + offset) % 7;
      var candidate = scheduleForDay(candidateDay, hours);
      if (!candidate) continue;

      if (offset === 1) return 'zítra v ' + formatTime(candidate.open);
      return DAY_PHRASE[candidateDay] + ' v ' + formatTime(candidate.open);
    }

    return '';
  }

  function updateElement(el) {
    var dot = el.querySelector('.opening-hours__dot');
    var text = el.querySelector('.opening-hours__text');
    if (!dot || !text) return;

    var hours = {
      monThuOpen: parseTime(el.dataset.monThuOpen),
      monThuClose: parseTime(el.dataset.monThuClose),
      friOpen: parseTime(el.dataset.fridayOpen),
      friClose: parseTime(el.dataset.fridayClose)
    };

    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Prague' }));
    var day = now.getDay();
    var currentMin = now.getHours() * 60 + now.getMinutes();
    var today = scheduleForDay(day, hours);

    if (today && currentMin >= today.open && currentMin < today.close) {
      var closeTime = formatTime(today.close);
      if (today.close - currentMin <= 30) {
        dot.className = 'opening-hours__dot opening-hours__dot--closing';
        text.textContent = 'Brzy zavíráme · do ' + closeTime;
      } else {
        dot.className = 'opening-hours__dot opening-hours__dot--open';
        text.textContent = 'Otevřeno · zavíráme v ' + closeTime;
      }
      return;
    }

    var opensAt = nextOpening(day, currentMin, hours);
    dot.className = 'opening-hours__dot opening-hours__dot--closed';
    text.textContent = opensAt ? 'Zavřeno · otevíráme ' + opensAt : 'Zavřeno';
  }

  function updateAll() {
    document.querySelectorAll('.opening-hours').forEach(updateElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  setInterval(updateAll, 60000);

  window.AvarrioOpeningHours = { update: updateAll };
})();
